/*
 * ListItemText.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./ListItemText.scss";

export interface IListItemTextProps {
	className?: string;
	primary?: React.ReactNode;
	secondary?: React.ReactNode;
	align?: "left" | "center" | "right";
}

export const ListItemText: React.FC<IListItemTextProps> = ({
	children,
	className,
	primary,
	secondary,
	align
}) => {
	const baseClass = BEM("edt-list-item-text", null, {
		align
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("primary").toClassName()}>
				<span>{primary || children}</span>
			</div>
			{secondary && <div className={baseClass.element("secondary").toClassName()}>{secondary}</div>}
		</div>
	);
};

ListItemText.defaultProps = {
	align: "center"
};
